import { 
  collection, 
  doc,
  addDoc,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { AuthService } from './authService';

const FEEDBACK_COLLECTION = 'feedback';

export class FeedbackService {
  /**
   * Submit user feedback or bug report
   * @param {Object} feedbackData - Feedback data containing type, subject, message, and metadata
   * @returns {Promise<string>} - Document ID of the created feedback
   */
  static async submitFeedback(feedbackData) {
    try {
      // Ensure user is authenticated
      if (!AuthService.isAuthenticated()) {
        // For feedback, we allow unauthenticated users but note it
        console.warn('User not authenticated, submitting feedback anonymously');
      }

      const user = AuthService.getCurrentUser();
      const userAddress = feedbackData.userAddress || null;
      
      // Generate feedback ID first for consistency
      const feedbackId = `feedback-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      
      // Prepare feedback document
      const feedbackDoc = {
        id: feedbackId,
        type: feedbackData.type || 'feedback', // 'feedback' or 'bug'
        subject: feedbackData.subject || '',
        message: feedbackData.message || '',
        userAddress: userAddress,
        userId: user?.uid || null,
        userEmail: user?.email || null,
        status: 'new',
        createdAt: serverTimestamp(),
        // Optional metadata
        browserInfo: feedbackData.browserInfo || null,
        deviceInfo: feedbackData.deviceInfo || null,
        url: feedbackData.url || window.location.href,
        chainId: feedbackData.chainId || null,
        walletType: feedbackData.walletType || null,
      };

      // Add feedback to Firestore
      const docRef = await addDoc(collection(db, FEEDBACK_COLLECTION), feedbackDoc);
      console.log('Feedback successfully submitted with ID:', docRef.id);
      return docRef.id;
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  }

  /**
   * Get browser and device information for bug reports
   * @returns {Object} Browser and device info
   */
  static getBrowserInfo() {
    const ua = navigator.userAgent;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(ua);
    
    return {
      userAgent: ua,
      platform: navigator.platform,
      language: navigator.language,
      isMobile: isMobile,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
    };
  }
}
